<template>
    <div class="VariableList pa-3">
        <v-layout>
            <v-text-field
                outlined
                dense
                hide-details
                v-model="searchKey"
                class="mb-3"
                :label="this.$f.tc('variable')"
            ></v-text-field>
            <v-select
                outlined
                dense
                hide-details
                clearable
                :label="this.$f.tc('entityType')"
                class="mx-3"
                :items="entityList"
                item-text="label"
                item-value="label"
                v-model="searchEntity"
            ></v-select>
            <v-select
                outlined
                dense
                hide-details
                clearable
                :label="this.$f.tc('validation')"
                :items="variableTypeList"
                item-text="name"
                item-value="type"
                v-model="searchValidation"
            ></v-select>
        </v-layout>
        <FCIDataTable :items="filterItems" :headers="headers">
            <template v-slot:name="props">
                <b>{{ props.item.name }}</b>
            </template>
            <template v-slot:action="props">
                <template v-if="props.item.builtin === 0">
                    <v-btn icon class="mr-3">
                        <v-icon @click="editItem(props.item, props.pagingIndex)">mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn icon>
                        <v-icon @click="deleteItem(props.item, props.pagingIndex)">mdi-delete</v-icon>
                    </v-btn>
                </template>
            </template>
        </FCIDataTable>
        <v-btn color="primary" class="mt-3" @click="addItem">{{ $f.tc('add') }}</v-btn>
    </div>
</template>

<script>
import ListViewMixin from '@/modules/fptai/mixins/ListViewMixin'
import { AppEventBusType } from '@/eventbus/app.eventbus'
import { mapState } from 'vuex'

export default {
    name: 'VariableList',
    mixins: [ListViewMixin],
    data () {
        return {
            searchEntity: '',
            searchValidation: ''
        }
    },
    computed: {
        ...mapState({
            entityList: state => state.scenario.entityList,
            variableTypeList: state => state.scenario.variableTypeList
        }),
        headers () {
            return [
                {
                    text: this.$f.tc('variable'),
                    value: 'name',
                    type: 'custom'
                },
                {
                    text: this.$f.tc('entityType'),
                    value: 'entity'
                },
                {
                    text: this.$f.tc('validation'),
                    value: 'memory_type_id'
                },
                {
                    text: this.$f.tc('action'),
                    value: 'action',
                    type: 'custom'
                }
            ]
        },
        filterItems () {
            let items = this.items
            let searchKey = this.$ut.noAccent(this.searchKey)
            if (searchKey) {
                items = items.filter(item => this.$ut.noAccent(item.name).includes(searchKey))
            }
            if (this.searchEntity) {
                items = items.filter(item => item.entity.includes(this.searchEntity))
            }
            if (this.searchValidation) {
                items = items.filter(item => item.memory_type_id === this.searchValidation)
            }
            return items
        }
    },
    methods: {
        refresh () {
            this.$store.dispatch(this.$at.scenario.LOAD_VARIABLE).then(() => {
                this.items = this.$store.state.scenario.variableList
                this.items.sort((a, b) => b.builtin - a.builtin)
                this.$forceUpdate()
            })
        },
        addItem () {
            this.$appService.useEventBus(AppEventBusType.OPEN_VARIABLE_EDITOR, null).then(item => {
                this.$store.dispatch(this.$at.scenario.CREATE_VARIABLE, {
                    name: item.name,
                    entity: item.entity,
                    memory_type_id: item.memory_type_id,
                    is_scenario_scope: false
                }).then(() => {
                    this.refresh()
                })
            })
        },
        editItem (item) {
            this.$appService.useEventBus(AppEventBusType.OPEN_VARIABLE_EDITOR, item).then(newItem => {
                this.$store.dispatch(this.$at.scenario.UPDATE_VARIABLE, {
                    id: item.id,
                    name: newItem.name,
                    entity: newItem.entity,
                    memory_type_id: newItem.memory_type_id
                }).then(() => {
                    this.refresh()
                })
            })
        },
        onDeleteItem (item) {
            this.$store.dispatch(this.$at.scenario.DELETE_VARIABLE, item).then(() => {
                this.refresh()
            })
        }
    }
}
</script>

<style scoped lang="scss">
.VariableList::v-deep table {
    table-layout: fixed;

    tr th {
        &:nth-child(2), &:nth-child(3), &:nth-child(4) {
            width: 180px;
        }
    }
}
</style>
